import { Switch } from "@/components/ui/switch";

const ALLERGENS = ["Dairy", "Eggs", "Fish", "Shellfish", "Tree nuts", "Peanuts", "Gluten", "Soy", "Sesame"];
const area = "w-full rounded-lg border border-[#E6E1D7] bg-white p-3 text-sm min-h-[80px]";

export function RecipeTypeSelect({ types, value, onChange, className }) {
  const foh = types?.foh || [], boh = types?.boh || [];
  const opts = [...foh, ...boh].includes(value) || !value ? null : <option value={value}>{value}</option>;
  return (
    <select className={className} value={value} data-testid="recipe-category"
      onChange={(e) => onChange({ category: e.target.value, domain: boh.includes(e.target.value) ? "boh" : "foh", is_batch: e.target.value === "Batch" })}>
      {opts}
      <optgroup label="Front of house (bar & beverage)">{foh.map((c) => <option key={`f-${c}`} value={c}>{c}</option>)}</optgroup>
      <optgroup label="Back of house (kitchen)">{boh.map((c) => <option key={`b-${c}`} value={c}>{c}</option>)}</optgroup>
    </select>
  );
}

export function RecipeStaffFields({ f, setF }) {
  const al = f.allergens || [];
  const toggle = (a) => setF({ ...f, allergens: al.includes(a) ? al.filter((x) => x !== a) : [...al, a] });
  return (
    <div className="space-y-2 pt-2 border-t border-[#F3EFE6]" data-testid="recipe-staff-fields">
      <label className="block text-xs text-stone-600">Method<textarea className={area} placeholder="Step-by-step preparation" value={f.instructions || ""} onChange={(e) => setF({ ...f, instructions: e.target.value })} data-testid="recipe-instructions" /></label>
      <label className="block text-xs text-stone-600">Presentation<textarea className={area} placeholder="Glassware, plating, garnish placement" value={f.presentation || ""} onChange={(e) => setF({ ...f, presentation: e.target.value })} data-testid="recipe-presentation" /></label>
      <div className="text-xs text-stone-600">Allergens
        <div className="flex flex-wrap gap-1.5 mt-1">{ALLERGENS.map((a) => (
          <button key={a} type="button" onClick={() => toggle(a)} aria-pressed={al.includes(a)} className={`h-8 px-3 rounded-full border text-xs ${al.includes(a) ? "bg-[#9E2A2B] text-white border-[#9E2A2B]" : "bg-white"}`} data-testid={`recipe-allergen-${a.toLowerCase().replace(/\s/g, "-")}`}>{a}</button>))}</div>
      </div>
      <label className="flex items-center justify-between rounded-lg bg-[#FBF9F5] p-3 text-sm">
        <span><span className="font-medium">Show to staff</span><span className="block text-xs text-stone-500">Publishes ingredients, method, presentation and allergens in the employee portal. Costs and prices stay hidden.</span></span>
        <Switch checked={!!f.staff_visible} onCheckedChange={(v) => setF({ ...f, staff_visible: v })} aria-label="Show this recipe in the staff Recipe Viewer" data-testid="recipe-staff-visible" />
      </label>
    </div>
  );
}
